"use client";
import React from "react";
import { cn } from "../../lib/utils";

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, readOnly, ...props }, ref) => {
    return (
      <input
        ref={ref}
        readOnly={readOnly}
        className={cn(
          "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-none focus:ring-1 focus:ring-orange-400",
          readOnly ? "bg-[#F4F4F4]" : "bg-white",
          className
        )}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";
